export const SET_ADMIN_STAKEHOLDER_EDIT_REQUEST = 'SET_ADMIN_STAKEHOLDER_EDIT_REQUEST';
export const SET_ADMIN_STAKEHOLDER_EDIT_SUCCESS = 'SET_ADMIN_STAKEHOLDER_EDIT_SUCCESS';
export const SET_ADMIN_STAKEHOLDER_EDIT_FAILED = 'SET_ADMIN_STAKEHOLDER_EDIT_FAILED';
export const SET_ADMIN_STAKEHOLDER_SUCCESS = 'SET_ADMIN_STAKEHOLDER_SUCCESS';
export const SET_ADMIN_STAKEHOLDER_SCENARIO_SUCCESS = 'SET_ADMIN_STAKEHOLDER_SCENARIO_SUCCESS';
export const SET_ADMIN_STAKEHOLDER_STAKEHOLDERS_LIST_SUCCESS = 'SET_ADMIN_STAKEHOLDER_STAKEHOLDERS_LIST_SUCCESS';
export const CLEAN_EDIT_STAKEHOLDER = 'CLEAN_EDIT_STAKEHOLDER';
